import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../services/supabase';
import { Layout, Typography, Divider, Form, Input, Button, message } from 'antd';
import { PhoneOutlined, LockOutlined, GoogleOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { Content } = Layout;

const Login = React.memo(() => {
  const [loading, setLoading] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [phone, setPhone] = useState('');
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const handleGoogleSignIn = async () => {
    try {
      const { data, error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: `${window.location.origin}/auth/callback`
        }
      });

      if (error) throw error;

    } catch (error) {
      message.error(error.message);
    }
  };

  const handleSendOTP = async (values) => {
    try {
      setLoading(true);
      const phoneNumber = values.phone;
      setPhone(phoneNumber);
      
      const { error } = await supabase.auth.signInWithOtp({
        phone: phoneNumber,
      });

      if (error) throw error;
      setOtpSent(true);
      message.success('OTP sent successfully');
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOTP = async (values) => {
    try {
      setLoading(true);
      const { data, error } = await supabase.auth.verifyOtp({
        phone: phone,
        token: values.otp,
        type: 'sms'
      });

      if (error) throw error;

      if (data && data.session) {
        message.success('Successfully signed in');
        navigate('/');
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout className="min-h-screen" style={{ background: '#f7f7f7' }}>

      <Content className="flex items-center justify-center p-8" style={{maxWidth: '800px', textAlign: 'center', margin: 'auto', padding: '50px 0'}}>
        <img 
            src='https://bvorqhdsibaukalonivs.supabase.co/storage/v1/object/public/images/public/0.7309657142709678-Vector%20(5).png' 
            height={30} 
            alt="Logo"
            style={{ cursor: 'pointer' }}
            onClick={() => navigate('/')}
        />
        <div className="w-full max-w-md bg-white p-8 rounded-lg shadow-md">
          <div className="text-center mb-6">
            <Title level={2} style={{ color: '#1a1a1a', marginBottom: 8 }}>
              Welcome
            </Title>
            <Text type="secondary">
              Sign in to continue to your account
            </Text>
          </div>

          {/* Google Sign In Button */}
          <Button
            icon={<GoogleOutlined />}
            onClick={handleGoogleSignIn}
            size="large"
            block
            style={{ 
              height: '50px',
              marginBottom: '24px'
            }}
          >
            Continue with Google
          </Button>

          <Divider>or sign in with phone</Divider>

          {!otpSent ? (
            <Form form={form} onFinish={handleSendOTP} layout="vertical">
              <Form.Item
                name="phone"
                rules={[
                  { required: true, message: 'Please input your phone number!' },
                  { pattern: /^\+91[1-9]\d{9}$/, message: 'Please enter valid Indian phone number' }
                ]}
                extra="Enter your phone number starting with +91 (e.g., +919876543210)"
              >
                <Input
                  prefix={<PhoneOutlined className="text-gray-400" />}
                  placeholder="+919876543210"
                  size="large"
                  style={{ height: '50px' }}
                />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  size="large"
                  loading={loading}
                  style={{ 
                    height: '50px',
                    backgroundColor: '#1a1a1a'
                  }}
                >
                  Send OTP
                </Button>
              </Form.Item>
            </Form>
          ) : (
            <Form form={form} onFinish={handleVerifyOTP} layout="vertical">
              <Form.Item
                name="otp"
                rules={[
                  { required: true, message: 'Please input the OTP!' },
                  { pattern: /^\d{6}$/, message: 'OTP must be 6 digits!' }
                ]}
              >
                <Input
                  prefix={<LockOutlined className="text-gray-400" />}
                  placeholder="Enter 6-digit OTP"
                  size="large"
                  style={{ height: '50px' }}
                />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  size="large"
                  loading={loading}
                  style={{ 
                    height: '50px',
                    backgroundColor: '#1a1a1a'
                  }}
                >
                  Verify OTP
                </Button>
                <Button
                  type="link"
                  block
                  onClick={() => {
                    setOtpSent(false);
                    form.resetFields();
                  }}
                  style={{ color: '#4CAF50', marginTop: '8px' }}
                >
                  Use Different Phone Number
                </Button>
              </Form.Item>
            </Form>
          )}
        </div>
      </Content>
    </Layout>
  );
});

export default Login;